export const HardpointTags = {
  zones: ['P1', 'P2', 'P3', 'P4', 'P5', 'Anchor Lane', 'Cutoff Lane', 'Hill Control', 'Top Control', 'Back Alley', 'Spawn Trap'],
  phases: ['Break', 'Hold', 'Rotation', 'Early Setup', 'Anchor Setup', 'Transition'],
  styles: ['Early Rotate', 'Full Push', 'Anchor Flip', 'Staggered Entry', 'Pinch Play', 'Solo Entry', 'Spawn Control']
};

export const SNDTags = {
  zones: ['A-Site', 'B-Site', 'Mid Control', 'Top Control', 'Flank Route', 'Back Alley'],
  phases: ['Defense', 'Attack'],
  styles: ['Contact Play', 'Fast Exec', 'Default Spread', 'Split Push', 'Solo Lurk', 'Stack Site', 'Fake A', 'Fake B']
};

export const CTLTags = {
  zones: ['A-Site', 'B-Site', 'Top Control', 'Flank Lane', 'Back Alley', 'Mid Lane', 'Spawn Trap', 'Stair Control'],
  phases: ['Defense', 'Attack'],
  styles: ['Full Stack', 'Split Cap', 'Stagger Push', 'Trophy Entry', 'Spawn Trap', 'Default Setup', 'Clutch Hold']
};
